import ApiService from '@/services/api.service'
import mime from 'mime-types'

const CheckupService = {

	/**
	 * Retourne un bilan d'une victime 
	 * @param {Number} victimId identifiant de la victime
	 * @param {Number} order numéro d'ordre du bilan
	 */
	getCheckup: async function(victimId, order) {
		const response = await ApiService.get('/api/checkups/'+ victimId + '/' + order);
		return response.data
	},

	/**
	 * Téléchargement de la synthèse du bilan en PDF
	 * @param {Number} victimId identifiant de la victime
	 * @param {Number} order numéro d'ordre du bilan
	 */
	downloadSynthesisPDF: async function(victimId, order) {
		const fileName = 'Bilan-'+ victimId + '-' + order + '.pdf';
		const url = '/file/checkup-pdf/'+ victimId + '/' + order;
		ApiService.download(url, fileName);
	},

	/**
	 * Téléchargement d'un fichier attaché au bilan
	 * @param {Number} victimId identifiant de la victime
	 * @param {Number} order numéro d'ordre du bilan
	 * @param {Number} num numéro du fichier
	 * @param {String} mimeType type du fichier
	 */
	downloadFile: async function(victimId, order, num, mimeType) {
		const ext = mime.extension(mimeType)
		const fileName = 'Bilan-'+ victimId + '-' + order + '-' + num + (ext ? '.' + ext : '');
		const url = '/file/checkup-file/' + victimId + '/' + order + '/' + num;
		ApiService.download(url, fileName);
	}

}

export default CheckupService